import type { TranslationTree } from '../../types';

export const errors: TranslationTree = {
  errors: {
    // Generic errors
    unknown: 'An unexpected error occurred. Please try again.',
    generic: 'Something went wrong. Please try again.',

    // Network errors
    network: {
      generic: 'Network error occurred. Please check your connection.',
      fetchFailed: 'Unable to connect to the server. Please check your internet connection.',
      requestFailed: 'Network request failed. Please try again.',
      timeout: 'The request took too long. Please try again.',
    },

    // API errors
    api: {
      unknown: 'An unexpected error occurred. Please try again.',
      badRequest: 'Invalid request. Please check your input and try again.',
      notFound: 'The requested resource was not found.',
      conflict: 'A conflict occurred. The resource may have been modified.',
      validationFailed: 'Validation failed. Please check your input.',
      rateLimited: 'Too many requests. Please wait a moment and try again.',
      serverError: 'A server error occurred. Please try again later.',
      badGateway: 'Bad gateway error. Please try again later.',
      unavailable: 'Service temporarily unavailable. Please try again later.',
      gatewayTimeout: 'Gateway timeout. The request took too long.',
      timeout: 'Request timed out. Please try again.',
      loadFailed: 'Failed to load data. Please try again.',
      saveFailed: 'Failed to save data. Please try again.',
      deleteFailed: 'Failed to delete. Please try again.',
      updateFailed: 'Failed to update. Please try again.',
    },

    // Authentication errors
    auth: {
      unauthorized: 'Unauthorized. Please log in.',
      forbidden: 'Access denied. You do not have permission.',
      authenticationFailed: 'Authentication failed. Please check your credentials.',
      invalidCredentials: 'Invalid email or password. Please try again.',
      sessionExpired: 'Your session has expired. Please log in again.',
      permissionDenied: 'You do not have permission to perform this action.',
    },

    // Validation errors
    validation: {
      required: 'This field is required.',
      fieldRequired: 'The {{field}} field is required.',
      emailInvalid: 'Please enter a valid email address.',
      emailRequired: 'Email is required.',
      passwordRequired: 'Password is required.',
      passwordTooShort: 'Password must be at least 8 characters.',
      passwordWeak: 'Password is too weak. Please use uppercase, lowercase, and numbers.',
      tooShort: 'This value is too short.',
      fieldTooShort: 'The {{field}} is too short.',
      tooLong: 'This value is too long.',
      fieldTooLong: 'The {{field}} is too long.',
      invalidFormat: 'Invalid format.',
      mustMatch: 'Values do not match.',
    },

    // Camera errors
    camera: {
      generic: 'Camera error occurred. Please try again.',
      notFound: 'No camera device found. Please check your camera connection.',
      permissionDenied: 'Camera access denied. Please allow camera permissions.',
      inUse: 'Camera is already in use by another application.',
      constraintFailed: 'Camera constraints could not be satisfied.',
      accessFailed: 'Failed to access camera. Please try again.',
    },

    // Data errors
    data: {
      parseFailed: 'Failed to parse data. The data format may be invalid.',
      processingFailed: 'Failed to process data. Please try again.',
      invalidFormat: 'Invalid data format.',
    },

    // Error boundaries
    boundary: {
      title: 'Something went wrong',
      description:
        'The application encountered an unexpected error and needs to reload. We apologize for the inconvenience.',
      reloadApp: 'Reload Application',
      tryAgain: 'Try Again',
      goBack: 'Go Back',
      goHome: 'Go Home',
      contactSupport: 'contact support',
      persistsPrefix: 'If this problem persists, please',
      errorDetails: 'Error Details (Development Only):',
      componentStack: 'Component Stack',
      stackTrace: 'Stack Trace',
      featureDescription: 'An error occurred in the {{feature}} feature. Please try again.',
    },

    // Action suggestions
    actions: {
      retry: 'Please try again.',
      pleaseLogin: 'Please log in to continue.',
      contactAdmin: 'Please contact your administrator.',
      checkUrl: 'Please check the URL and try again.',
      waitAndRetry: 'Please wait a moment and try again.',
      tryAgainLater: 'Please try again later.',
      checkConnection: 'Please check your internet connection.',
      checkCameraPermission: 'Please check camera permissions in your browser settings.',
      reload: 'Please reload the page.',
      goBack: 'Please go back and try again.',
    },
  },
};
